import React from 'react';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import useMediaQuery from '@mui/material/useMediaQuery';

// REMOVE THE IMPORT for Main
import Main from 'views/layouts/Main/Main';

import SimContainer from 'components/SimContainer';
import {
    /* Content, */
    FooterNewsletter,
    Hero,
    SidebarArticles,
    SimilarStories,
    Main as MainSection
} from './components';

const ResourceSample = () => {
    const theme = useTheme();
    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true
    });

    // The <Main> wrapper is removed. We use a React Fragment <> instead.
    return (
        <Main colorInvert={true}>
            <Box>
                <Hero />

                <Box padding={6}>
                    <Grid container spacing={4}>
                        <Grid item xs={12} md={8}>
                            <MainSection />
                            {/* <Content /> */}
                        </Grid>

                        <Grid item xs={12} md={4}>
                            {isMd ? (
                                <Box marginBottom={4}>
                                    <SidebarArticles />
                                </Box>
                            ) : null}
                            {/* <SidebarNewsletter /> */}
                        </Grid>
                    </Grid>
                </Box>

                <Box
                    component={'svg'}
                    preserveAspectRatio='none'
                    xmlns='http://www.w3.org/2000/svg'
                    x='0px'
                    y='0px'
                    viewBox='0 0 1920 100.1'
                    sx={{
                        marginBottom: -1,
                        width: 1
                    }}>
                    <path fill={theme.palette.primary.main} d='M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z'></path>
                </Box>
            </Box>
            <Box bgcolor={'alternate.main'}>
                <SimContainer>
                    <SimilarStories />
                </SimContainer>
                <SimContainer>
                    <FooterNewsletter />
                </SimContainer>
                <Box
                    component={'svg'}
                    preserveAspectRatio='none'
                    xmlns='http://www.w3.org/2000/svg'
                    x='0px'
                    y='0px'
                    viewBox='0 0 1920 100.1'
                    sx={{
                        marginBottom: -1,
                        width: 1
                    }}>
                    <path fill={theme.palette.background.default} d='M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z'></path>
                </Box>
            </Box>
        </Main>
    );
};

export default ResourceSample;